import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'zikatagov-button',
  template: `
    <button
      class="btn"
      [ngClass]="[
        outline ? 'btn-outline-' + color : 'btn-' + color,
        'btn-' + size
      ]"
      [disabled]="disabled"
    >
      <ng-container *ngIf="iconLeft">
        <i [ngClass]="iconLeft" class="me-2"></i>
      </ng-container>
      <ng-content></ng-content>
      <ng-container *ngIf="iconRight">
        <i [ngClass]="iconRight" class="ms-2"></i>
      </ng-container>
    </button>
  `,
  standalone: true,
  imports: [CommonModule]
})
export class ZikataButtonComponent {
  @Input() color = 'primary';
  @Input() outline = false;
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() disabled = false;
  @Input() iconLeft?: string;
  @Input() iconRight?: string;
}